module.exports = __webpack_public_path__ + "img/icon04.456ea855.png";